import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroup = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.29999 18.7V5.30005H10.3V18.7H5.29999Z",
		fill: "#281E38",
		stroke: "#281E38",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.2 18.2V5.80005H18.2V18.2H14.2Z",
		stroke: "#281E38",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgGroup);
export default ForwardRef;
